<template>
  <div class="relative inline-block text-left mt-2">
    <div>
      <button type="button" @click.stop="toggle"
      class="flex text-sm focus:outline-none transition duration-150 ease-in-out"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="text-gray-500 w-8 h-8 hover:text-markencode-blue"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
          />
        </svg>
      </button>
    </div>

    <transition enter-active-class="transition ease-out duration-100" enter-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
      leave-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <div v-if="show" v-click-outside="hide"
        class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
        <div class="py-1" role="none">
          <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
          <a :href="route('diy-workshops.imprint', { uuid: this.participant.uuid })" class="block px-4 py-2 text-sm text-gray-700 hover:text-markencode-blue" role="menuitem" tabindex="-1"
            id="menu-item-0">Impressum</a>
          <a :href="route('diy-workshops.data-privacy', { uuid: this.participant.uuid })" class="block px-4 py-2 text-sm text-gray-700 hover:text-markencode-blue" role="menuitem" tabindex="-1"
            id="menu-item-1">Datenschutz</a>
        </div>
      </div>
    </transition>

  </div>

</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    ClickOutside,
  },

  props: {
    participant: Object,
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    toggle() {
      this.show = !this.show;
    },

    hide() {
      this.show = false;
    },
  },

};
</script>